import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {type ReactElement} from 'react';
import styles from './ai-prompt-box-issue.module.scss';
import {useAiPromptBox} from "@Components/ai-prompt-box/hooks/useAiPromptBox";

import {ErrorType} from "@Components/ai-prompt-box/components/ai-prompt-box-issue/ai-prompt-box-issue.types";

interface AiRedesignIssueProps {
  id: string;
  retry: () => void;
}

export function AiPromptBoxIssue({id, retry}: AiRedesignIssueProps): ReactElement|null {
  const {state} = useAiPromptBox(id);
  const error = state.error;

  if (!error) {
    return null;
  }

  const getRedesignIssue = (): ReactElement => {
    return (
      <div
        className={`flexbox gap-1 spacing-m-t-2 spacing-m-l-2 ${styles.redesignIssueBox}  ${error.type === ErrorType.ERROR ? styles.redesignIssueError : styles.redesignIssueWarning}`}
      >
        <Icon icon={error.icon} size={IconSize.SIZE_ICON_16} className={styles.redesignIssueIcon} />
        <Text val={error.message} size={TextSize.XSMALL} />
        <Text val={window.i18next.t('pmwjs_retry')} className={'_cursor-pointer'} bold size={TextSize.XSMALL} underline onClick={retry}/>
      </div>
    );
  };

  return getRedesignIssue();
}
